import { z } from 'zod'
import { createIncomeTemplateSchema } from './create-income-template.schema'

export const updateIncomeTemplateSchema = createIncomeTemplateSchema.partial()

export type UpdateIncomeTemplateDto = z.infer<typeof updateIncomeTemplateSchema>
